import { Spinner } from '@chakra-ui/react';
import React from 'react';
import { keepPreviousData } from '@tanstack/react-query';
import { unwrapModel } from '../../../services/api/unwrapModel';
import { getGetRemoteSubmissionInvitesQueryKey, useGetRemoteSubmissionInvites, } from '../../../services/api/generated/client';
import { ErrorAwareAlertBox } from '../ErrorAwareAlertBox/ErrorAwareAlertBox';
import { FIVE_MIN_STALE_TIME, queryClient, } from '../../../services/api/query/queryClient';
import RemoteSubmissionInvitesTable from '../RemoteSubmissionInvitesTable/RemoteSubmissionInvitesTable';
import usePages from '../../../hooks/usePages';
import { buildPaginationFromResponse } from '../../../services/pagination';
const SentInvitationsContent = ({ inspection }) => {
    const { incrementPage, decrementPage, page, setPage } = usePages();
    const { data: response, isError, error, isFetching, } = useGetRemoteSubmissionInvites(inspection.id, {
        should_paginate: 1,
        page,
    }, {
        query: {
            placeholderData: keepPreviousData,
            staleTime: FIVE_MIN_STALE_TIME,
        },
    });
    if (isError || error) {
        return React.createElement(ErrorAwareAlertBox, { error: error });
    }
    const invites = unwrapModel(response);
    if (!invites && isFetching) {
        return React.createElement(Spinner, { size: "lg" });
    }
    const invalidate = () => {
        queryClient.invalidateQueries({
            queryKey: getGetRemoteSubmissionInvitesQueryKey(inspection.id),
        });
    };
    const onRemoteSubmissionInvitesMutated = () => {
        invalidate();
    };
    const onInviteResent = () => {
        invalidate();
        setPage(1);
    };
    const pagination = buildPaginationFromResponse(response, incrementPage, decrementPage);
    return (React.createElement(RemoteSubmissionInvitesTable, { pagination: pagination, invites: invites, onMutated: onRemoteSubmissionInvitesMutated, isFetching: isFetching, onInviteResent: onInviteResent }));
};
export default SentInvitationsContent;
